import React from 'react';
import { Marker as GoogleMarker } from '@react-google-maps/api';

//css
//Actions
//img
export default function Marker(props) {
  return <GoogleMarker {...props} />;
}
